<template>
  <div class="root">
    <!--    <div class="icon-wrapper">-->
    <!--      <img class="icon" :src="icon">-->
    <!--    </div>-->
    <div class="circle-icon-wrapper">
      <div class="circle-icon">
        <img class="circle-icon-image" :src="icon">
      </div>
    </div>
    <b-card class="card" no-body>
      <div class="template">
        <b-card-text class="title">
          {{ title }}
        </b-card-text>
        <b-card-text class="description">
          <ul>
            <li v-for="(item, index) in items" :key="index">
              {{ item }}
            </li>
          </ul>
        </b-card-text>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'IconCard',
  components: {
    BCard
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

    .root {
        height: 100%;
    }

    .title {
        margin-bottom: 8px;
        color: #48465B;
        opacity: 1;
        font-weight: 600;
        font-size: 14px;
        white-space: pre-line;
    }

    .description {
        font-size: 14px;
        color: #6C757D;
    }

    ul {
        padding-left: 18px;
        margin: 0;
    }

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        height: calc(100% - 50px);
        overflow: visible;
        position: static;
        padding: 67px 28px 28px;
    }

    .template {
        display: flex;
        flex-direction: column;
        /*align-items: center;*/
        overflow-y: hidden;
    }

    .circle-icon-wrapper {
      margin-right: auto;
      margin-left: auto;
      margin-bottom: -50px;
      z-index: 2;
      position: relative;
      height: 100px;
      width: 100px;
    }

    .circle-icon {
      background: #6F4FFF;
      border-radius: 50%;
      padding: 21.875%;
    }

    .circle-icon-image {
      max-width: 100%;
      max-height: 100%;
    }
</style>
